const normalizeComparableStatus = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim().toLowerCase();
};

export const computeStatusMatch = (row) => {
  if (!row) return false;
  const dpe = normalizeComparableStatus(row?.productSelectionStatus ?? row?.productSelectionStatusCd ?? row?.status ?? '');
  const di = normalizeComparableStatus(row?.diStatus ?? '');
  if (!dpe || !di) return false;
  return dpe === di;
};

export const getStatusMatchMeta = (isMatch) => ({
  label: isMatch ? 'true' : 'false',
  color: isMatch ? 'success' : 'error',
});

export const pickSelectionValue = (selection, keys) => {
  if (!selection) return null;
  for (const key of keys) {
    if (!Object.prototype.hasOwnProperty.call(selection, key)) continue;
    const value = selection[key];
    if (value === null || value === undefined) continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    return value;
  }
  return null;
};

